<template>
  <div>
    <div v-if="debug_show_page_name==true" style="color:green;">device-modal</div>
    <modal class="device_select-modal" width="460px"   :value="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <center><strong>機器管理番号</strong></center>
        </h4>
      </div>
      <div  class="modal-body device_select-modal-body " style="height: 500px;padding: 0px 15px; overflow-x: auto;" >
        <ag-grid-vue style="min-width:100px;width: 100%; height: 475px" class="ag-blue" :gridOptions="gridOptions" :rowData="rowData"></ag-grid-vue>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <div style="float:left">
          <input class="form-control"  type="text" placeholder="検索"
          id="device-search" name="device-search"
          :value="searchModel"
          @input="onSearch($event.target.value)"
          >
        </div>
        <button type="button" class="btn btn-default " @click="closed('no')">キャンセル</button>
        <button type="button" class="btn btn-primary " @click="closed('yes')" >OK</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { bus } from '@/libs/bus';
import { utils } from '@/libs/utils';
var vm = this;

import modal from './local-modal';
import output_config from '../../rules/output_config.js';
import { AgGridVue } from 'ag-grid-vue';
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";

Vue.component('modal', modal);
import _ from 'lodash';
import debug from 'debug';
var debug_device = debug('esma:device-modal');
export default {
   mixins:[
        mixinPageCommon,mixinDatasource
  ],
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      show_modal: false,
      selected_data :false,
      row_data:[],
      api_name:"device_embedded_information",
      search_timeout : false,
      search_model:"",
      state_last_filter_options:"last_filter_options3"
    };
  },
  computed: {
    searchModel:{
      get(){
        return this.search_model;
      },
      set(v){
        this.search_model = v;
      }
    },
    rowData:{
      get(){
        return this.row_data;
      },
      set(v){
        this.row_data = v;
      }
    },
    selectedData:{
      get(){
        return this.selected_data;
      },
      set(v){
        this.selected_data = v;
      }
    },

    pageID() {
      return this.$props.pageid;
    },
    showModal() {
      return this.show_modal;
    }
  },
  methods: {
    onSearch(txt){
      clearTimeout(this.search_timeout);
      this.search_timeout = setTimeout(()=>{
        this.searchControlChangedDatasource(
          {
            "1":{block: "1", field: "device_control_number", value: "NOT_EMPTY_VALUE", ct: "v", ca: false, t: "input"},
            "2":(txt == "")?false:{block: "2", field: "device_control_number", value: txt, ct: "v", ca: false, t: "input"},
            "3": false,
            "j1": "AND",
            "j2": "AND",
            "b2_disabled": false,
            "b3_disabled": true
          }
        )
      },(txt == "")?0:300)
    },
    cancelCurrentSelection() {
      //Dummy, needed due mixinDataSource
    },
    updateValue(vm, ev, mode, cb=()=>{}){
      if (ev.node.isSelected()) {
        this.selectedData = ev.node.data.device_control_number;
      }
    },
    onShow() {
        this.onSearch("");
        this.searchModel = "";
        this.selectedData = false;
         this.$notify({clean: true});
        this.$notify({
          title: "Loadding....",
          type: "success",
          duration: 1000
        });
    },
    showModalWindow() {
      debug_device("showModalWindow");
      this.onShow();
      this.show_modal = true;
    },
    closed(mode) {
      debug_device('mode', mode);
      if(mode == "yes" && this.selectedData){
        this.$emit("selected",this.selectedData)
        setTimeout(()=>{
          this.selectedData = "";
          this.selectedData = false;
        },100)
      }else if(mode == "yes"){
        var last_terminal = false;
        var count_rows = 0;
        this.gridOptions.api.forEachNode((node) => {
          if(typeof node != "undefined" && typeof node.data != "undefined"  ){
            if(typeof node.data.seq_id != "undefined"){
              if(count_rows == 0){
                last_terminal = node.data.device_control_number;
              }
              count_rows++;
            }
          }
        })
        if(count_rows == 1 && last_terminal != false){
          this.$emit("selected",last_terminal)
        }
      }
      this.show_modal = false;
      this.$emit('done', mode);
    },
    createColumnDefs(){
      return [
        {
          headerName: '機器管理番号',
          field: 'device_control_number',
          hide: false,
          sort: 'desc',
          width:392
        },
        {
          headerName: 'Seq', 
          field: 'seq_id',
          hide: false,
          sort: 'desc',
          width:392
        },
        {
            headerName: "SearchFlowControl",// Used to filter manually
            field: "search_flow_control",
            hide: false
        },
    ];
    }
  },
  props: {
    tag: { type: String, default: 'showdeviceModal' },
    pageid: { type: String }
  },
   beforeMount() {
    // this.$store.state.current_row = {};

    //AG Grid options
    this.gridOptions = {
      defaultColDef: {
        editable: false
      },
      getRowNodeId: function(data) {
        return data.seq_id;
      },
      enableSorting: true,
      enableColResize: false,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressHorizontalScroll: true,
      overlayNoRowsTemplate :"<span class=\"ag-overlay-loading-center\">対象のデータはありません</span>",
      onRowSelected: ev => {
        this.updateValue(this, ev, 'load_device');
      },
    };
    this.initDatasource({load_only_with_filter:true});
  },
  mounted() {
    debug_device('On mounted');
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};

</script>
<style scoped>

.info_div {
  width: 32%;
  float: left;
}
.mh_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.mh_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
.fa-spin-custom, .glyphicon-spin {
    -webkit-animation: spin 1500ms infinite linear;
    animation: spin 1500ms infinite linear;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
</style>



// WEBPACK FOOTER //
// device-modal.vue?2c589bc0